module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-medium-webfont.8bea9913.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-medium-webfont.ttf
// module id = 376
// module chunks = 3